module.exports = __webpack_public_path__ + "img/H1.63d60d0e.png";